import React from 'react';
import styled from 'styled-components';
import { UrlItem } from './url-item.component';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "url-listcomponent__Container",
  componentId: "sc-b2qbxa-0"
})(["display:flex;flex-direction:column;gap:12px;margin-top:20px;"]);
var ListHeader = styled.div.withConfig({
  displayName: "url-listcomponent__ListHeader",
  componentId: "sc-b2qbxa-1"
})(["font-size:12px;font-weight:700;color:#8b95b0;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:4px;"]);
var ListContent = styled.div.withConfig({
  displayName: "url-listcomponent__ListContent",
  componentId: "sc-b2qbxa-2"
})(["display:flex;flex-direction:column;gap:8px;max-height:240px;overflow-y:auto;padding-right:4px;&::-webkit-scrollbar{width:4px;}&::-webkit-scrollbar-track{background:transparent;}&::-webkit-scrollbar-thumb{background:#e0e4ef;border-radius:4px;}"]);
export var UrlList = function UrlList(_ref) {
  var urls = _ref.urls,
      _onRemove = _ref.onRemove;
  if (urls.length === 0) return null;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(ListHeader, {
      children: ["ADDED URLS (", urls.length, ")"]
    }), /*#__PURE__*/_jsx(ListContent, {
      children: urls.map(function (url) {
        return /*#__PURE__*/_jsx(UrlItem, {
          url: url,
          onRemove: function onRemove() {
            return _onRemove(url);
          }
        }, url);
      })
    })]
  });
};